/**
 * useTickets Hook
 * Fetch tickets list with filters and pagination
 */

import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-client';
import { PaginatedTickets, TicketFilters } from '@/types';

export function useTickets(projectId: string, filters?: TicketFilters) {
  const normalizedFilters = {
  ...filters,
  priority: filters?.priority
    ? Array.isArray(filters.priority)
      ? filters.priority
      : [filters.priority]
    : undefined,
};
  return useQuery({
    queryKey: [
      'tickets',
      projectId,
      JSON.stringify(normalizedFilters || {})
    ],
    queryFn: async () => {
      const params = new URLSearchParams();

      if (normalizedFilters?.status?.length) {
        normalizedFilters.status.forEach((s) => params.append('status', s));
      }
      if (normalizedFilters?.priority?.length) {
        normalizedFilters.priority.forEach((p) => params.append('priority', p));
      }
      if (normalizedFilters?.type?.length) {
        normalizedFilters.type.forEach((t) => params.append('type', t));
      }
      if (normalizedFilters?.assignee_id?.length) {
        normalizedFilters.assignee_id.forEach((id: string) =>
          params.append('assignee_id', id)
        );
      }
      if (normalizedFilters?.reporter_id) {
        params.append('reporter_id', normalizedFilters.reporter_id);
      }
      if (normalizedFilters?.epic_id) {
        params.append('epic_id', normalizedFilters.epic_id);
      }
      if (normalizedFilters?.search) {
        params.append('search', normalizedFilters.search);
      }
      if (normalizedFilters?.sort) {
        params.append('sort', normalizedFilters.sort);
      }
      if (normalizedFilters?.limit) {
        params.append('limit', normalizedFilters.limit.toString());
      }
      if (normalizedFilters?.cursor) {
        params.append('cursor', normalizedFilters.cursor);
      }

      const { data } = await apiClient.get<PaginatedTickets>(
        `/projects/${projectId}/tickets?${params.toString()}`
      );
      return data;
    },
    enabled: !!projectId,
    keepPreviousData: true, 
  });
}
